// src/layouts/PatientLayout.jsx
import React, { useMemo, useState } from "react";
import PatientDetail from "../components/PatientDetail.jsx";
import PatientFollowUp from "../components/PatientFollowUp.jsx";
import { useSidebar } from "./SidebarContext.jsx";
import { Menu, X } from "lucide-react";
import "../styles/patients/patientslayout.css";

const PatientLayout = () => {
  const [activeTab, setActiveTab] = useState("detail");
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const tabs = useMemo(
    () => [
      { key: "detail", label: "Ficha" },
      { key: "followup", label: "Seguimiento" },
    ],
    []
  );

  return (
    <div className="patients-page-container">
      {/* Tabs + botón menú */}
      <div className="patients-tabs-row">
        <button
          type="button"
          className="page-menu-btn patients-menu-btn"
          onClick={toggleSidebar}
          aria-label={isSidebarOpen ? "Cerrar menú" : "Abrir menú"}
        >
          {isSidebarOpen ? <X size={18} /> : <Menu size={18} />}
        </button>

        <div className="patients-tabs segmented" role="tablist" aria-label="Secciones del paciente">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.key;

            return (
              <button
                key={tab.key}
                type="button"
                className={`patients-tab segmented-btn ${isActive ? "is-active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
                role="tab"
                aria-selected={isActive ? "true" : "false"}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Contenido según tab */}
      <div className="patients-tab-content">
        {activeTab === "detail" && <PatientDetail />}
        {activeTab === "followup" && <PatientFollowUp />}
      </div>
    </div>
  );
};

export default PatientLayout;